import React, { useState } from "react";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import Button from "@mui/material/Button";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";

import ScanditScanner from "./ScanditScanner/ScanditScanner";

const BarCodeInput = ({ onChange, id }) => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const toggleOpen = () => setOpen(v => !v);

  const closeScanner = () => setOpen(false);

  const handleScan = code => {
    setLoading(true);

    onChange(code, {
      onSuccess: () => {
        setLoading(false);
      },
      onFailure: () => {
        setLoading(false);
      },
    });
  };

  if (open) {
    return (
      <ScanditScanner
        onDetected={handleScan}
        onClose={closeScanner}
      />
    );
  }

  return (
    <Box id={id} display="flex" flexDirection="column" height="100%" justifyContent="space-between">
      <Button
        sx={{ height: 40, borderWidth: 2, '&:hover': { borderWidth: 2 } }}
        variant="outlined"
        color="primary"
        fullWidth
        disabled={loading}
        onClick={toggleOpen}
      >
        <QrCodeScannerIcon sx={{ fontSize: 26, color: 'primary.main' }} />
      </Button>
      {loading && <LinearProgress sx={{ mt: 2 }} />}
    </Box>
  );
};

export default BarCodeInput;
